export class signatureStatusUrl {
    SIGNATURE_STATUS_URL = "sig/v1/status/download-status";
}
